import React from 'react';
import { Container } from 'react-bootstrap';
import Table from 'react-bootstrap/Table';
import PropTypes from 'prop-types';
import 'bootstrap/dist/css/bootstrap.min.css';

const ShowPaxtable = ({ paxDetails }) => (
  <Container>
    <Table
      responsive
      style={{
      backgroundColor: '#f9f9f9',
      borderRadius: '8px',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
     }}
    >
      <thead className="bg-primary" style={{ color: 'white', textAlign: 'center' }}>
        <tr>
          <th>#</th>
          <th>Name</th>
          <th>Email</th>
          <th>Contact No.</th>
          <th>Age Group</th>
        </tr>
      </thead>
      <tbody>
        {paxDetails.map((item, index) => (
          <tr key={item.id} style={{ textAlign: 'center' }}>
            <td>{index + 1}</td>
            <td>{item?.pax_name}</td>
            <td>{item?.email_id || 'NA'}</td>
            <td>{item?.mobile_no || 'NA'}</td>
            <td>{item?.age_group === '1' ? (
              <span>Adult
              </span>
) : <span>Child</span>}
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  </Container>
);

ShowPaxtable.propTypes = {
  paxDetails: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      pax_name: PropTypes.string.isRequired,
      email_id: PropTypes.string.isRequired, // Ensure you use the correct key
      mobile_no: PropTypes.string.isRequired, // Assuming status is a string like "confirmed"
      age_group: PropTypes.string.isRequired, // Assuming status is a string like "confirmed"
    }),
  ).isRequired,
};

export default ShowPaxtable;
